import { Severity } from '@cobliteam/common-types';

import { UserAlertSettingsBuilder } from '@cobliteam/api-lib/src/__builder__';

import { SettingsType } from '../../commons';

const defaultRoadSpeedLimitSettings = () =>
  new UserAlertSettingsBuilder()
    .withId(undefined)
    .withType(SettingsType.ROAD_SPEED_LIMIT)
    .withActive(false)
    .withSettingsJson({
      durationAboveLimitInMillis: 60000,
      severity: Severity.VERY_SEVERE,
      vehicleGroupIds: [],
    })
    .build();

const defaultVehicleSpeedLimitSettings = () =>
  new UserAlertSettingsBuilder()
    .withId(undefined)
    .withType(SettingsType.VEHICLE_SPEED_LIMIT)
    .withActive(false)
    .withSettingsJson({
      durationAboveLimitInMillis: 60000,
      vehicleGroupIds: [],
    })
    .build();

const defaultStopIdleTimeSettings = () =>
  new UserAlertSettingsBuilder()
    .withId(undefined)
    .withType(SettingsType.STOP_IDLE_TIME)
    .withActive(false)
    .withSettingsJson({ durationIdleInMillis: 600000, vehicleGroupIds: [] })
    .build();

export const getDefaultSetupSettings = () => [defaultRoadSpeedLimitSettings(), defaultVehicleSpeedLimitSettings(), defaultStopIdleTimeSettings()];

export default getDefaultSetupSettings;
